import { fsErrorMessages } from '@repo/lib/messages/fsErrorMessages';
import { useQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { DirectoryService } from './directoryService';
import { DirectoryKey } from './keys';

export function useGetDirectoryPermissions(id?: string, enabled = true) {
  const getDirectoryPermissionsQuery = useQuery({
    queryKey: [DirectoryKey.DIRECTORY_PERMISSIONS, id],
    queryFn: () => DirectoryService.getDirectoryPermissions(id).then((response) => response.data),
    enabled: enabled && !!id,
  });

  const errorMessage = useErrorMessage(getDirectoryPermissionsQuery.error, fsErrorMessages);

  return { ...getDirectoryPermissionsQuery, errorMessage };
}
